export const pricingLicenseNote = "Licence CFJJB incluse dans le tarif";
export const pricingPaymentNote = "Paiement en 3 fois possible";

export const membershipPlan = {
    id: "mixte",
    title: "JJB + MMA + Grappling",
    description: "Une seule adhésion pour accéder aux trois disciplines du club.",
    audience: "Enfants et adultes · tous âges",
    amount: 350,
    features: ["Accès JJB, MMA et grappling", "Cours adaptés à chaque niveau", "Loisir ou compétition"],
} as const;

export const membershipSummary = `Tarif unique : ${membershipPlan.amount} € par an pour enfants et adultes. Accès ${membershipPlan.title}. ${pricingLicenseNote}. ${pricingPaymentNote}.`;
